 /** import GoogleMapReact from 'google-map-react';

const Marker = ({ text }) => (
  <div className="text-red-600 text-xs font-semibold bg-white px-1 py-0.5 rounded shadow">
    {text}
  </div>
);

const MapView = ({ lat, lng }) => {
  if (!lat || !lng) return null;

  const defaultCenter = { lat: Number(lat), lng: Number(lng) };

  return (
    <div className="h-64 w-full rounded-lg overflow-hidden border mt-4">
      <GoogleMapReact
        bootstrapURLKeys={{ key: 'YOUR_GOOGLE_MAPS_API_KEY' }}
        defaultCenter={defaultCenter}
        defaultZoom={16}
      >
        <Marker lat={defaultCenter.lat} lng={defaultCenter.lng} text="Garbage Spot" />
      </GoogleMapReact>
    </div>
  );
};

export default MapView;
**/

// src/components/common/MapView.js
import L from 'leaflet';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';

// Fix default marker icon (otherwise you see blue squares / no icon in some setups)
import 'leaflet/dist/leaflet.css';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl:
    'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl:
    'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const MapView = ({ lat, lng }) => {
  if (!lat || !lng) return null;

  const center = [Number(lat), Number(lng)]; // Leaflet uses [lat, lng]

  return (
    <div className="h-64 w-full rounded-lg overflow-hidden border mt-4">
      <MapContainer
        center={center}
        zoom={16}
        scrollWheelZoom={false}
        style={{ height: '100%', width: '100%' }}
      >
        <TileLayer
          // Free OpenStreetMap tiles
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <Marker position={center}>
          <Popup>Garbage Spot</Popup>
        </Marker>
      </MapContainer>
    </div>
  );
};

export default MapView;
